import { Skeleton } from "@/components/ui/skeleton";

export default function KanbanLoading() {
  return (
    <div className="aero:w-full aero:space-y-6">
      {/* Kanban Columns */}
      <div className="aero:grid aero:grid-cols-1 aero:md:grid-cols-4 aero:gap-6">
        {/* Generate 4 columns */}
        {Array.from({ length: 4 }).map((_, colIndex) => (
          <div key={colIndex} className="aero:space-y-4">
            {/* Column Header */}
            <div className="aero:flex aero:items-center aero:justify-between">
              <div className="aero:flex aero:items-center aero:gap-2">
                <Skeleton className="aero:h-3 aero:w-3 aero:!rounded-full" />
                <Skeleton className="aero:h-5 aero:w-24" />
                <Skeleton className="aero:h-5 aero:w-6 aero:!rounded-full" />
              </div>
              <Skeleton className="aero:h-8 aero:w-8" />
            </div>

            {/* Cards - generate 2-3 cards per column */}
            {Array.from({ length: 2 + Math.floor(Math.random() * 2) }).map(
              (_, cardIndex) => (
                <div
                  key={cardIndex}
                  className="aero:border aero:!rounded-lg aero:p-4 aero:space-y-3"
                >
                  <div className="aero:flex aero:items-center aero:gap-2">
                    <Skeleton className="aero:h-6 aero:w-6" />
                    <Skeleton className="aero:h-4 aero:w-32" />
                  </div>
                  <Skeleton className="aero:h-4 aero:w-full" />
                  <Skeleton className="aero:h-4 aero:w-3/4" />
                  <div className="aero:flex aero:items-center aero:justify-between aero:pt-2">
                    <div className="aero:flex aero:gap-2">
                      <Skeleton className="aero:h-6 aero:w-16" />
                      <Skeleton className="aero:h-6 aero:w-24" />
                    </div>
                    <div className="aero:flex aero:-space-x-2">
                      {Array.from({ length: 3 }).map((_, i) => (
                        <Skeleton
                          key={i}
                          className="aero:h-8 aero:w-8 aero:!rounded-full aero:border-2 aero:border-background"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
